import React, { useEffect, useState } from 'react';
import { auth, db } from '../firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { onAuthStateChanged } from 'firebase/auth';
import BackHomeButton from '../components/BackHomeButton';
import { useNavigate } from 'react-router-dom';

const UserTestDashboard = () => {

  const navigate = useNavigate(); // ADD THIS


  const [user, setUser] = useState(null);
  const [results, setResults] = useState([]);
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [expandedSubject, setExpandedSubject] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (!currentUser) {
        alert('Please log in to view your dashboard');
      } else {
        setUser(currentUser);
        const q = query(collection(db, 'AI_Results'), where('uid', '==', currentUser.uid));
        const snapshot = await getDocs(q);
        const data = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setResults(data.sort((a, b) => b.timestamp.toDate() - a.timestamp.toDate()));
      }
    });
    return () => unsubscribe();
  }, []);

  // 🔎 Aggregate performance by subject with deduplication
  const performanceBySubject = results.reduce((acc, test) => {
    const subject = test.subject || 'Unknown';
    const lessonOrTopic = test.lesson || test.topic || 'Untitled';

    if (!acc[subject]) {
      acc[subject] = { strong: new Set(), moderate: new Set(), weak: new Set() };
    }

    if (test.score >= 80) {
      acc[subject].strong.add(lessonOrTopic);
    } else if (test.score >= 50) {
      acc[subject].moderate.add(lessonOrTopic);
    } else {
      acc[subject].weak.add(lessonOrTopic);
    }

    return acc;
  }, {});

  // Convert sets → arrays for rendering
  Object.keys(performanceBySubject).forEach(subject => {
    performanceBySubject[subject].strong = Array.from(performanceBySubject[subject].strong);
    performanceBySubject[subject].moderate = Array.from(performanceBySubject[subject].moderate);
    performanceBySubject[subject].weak = Array.from(performanceBySubject[subject].weak);
  });

  const toggleExpand = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const cardStyle = {
    border: '1px solid #e0e0e0',
    borderRadius: '12px',
    marginBottom: '20px',
    padding: '20px',
    background: '#ffffff',
    boxShadow: '0 4px 8px rgba(0,0,0,0.06)',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
    cursor: 'pointer'
  };

  const cardHoverStyle = {
    ...cardStyle,
    transform: 'translateY(-2px)',
    boxShadow: '0 8px 16px rgba(0,0,0,0.08)'
  };

  return (
    <div style={{ maxWidth: '900px', margin: '0 auto', padding: '30px 20px', fontFamily: 'sans-serif' }}>
      <BackHomeButton />

      {/* 📊 Performance Summary */}
      {/*
      {Object.entries(performanceBySubject).map(([subject, performance], index) => (
        <div key={index} style={{ marginBottom: '12px' }}>
          <div
            onClick={() =>
              setExpandedSubject(expandedSubject === subject ? null : subject)
            }
            style={{
              cursor: 'pointer',
              fontWeight: 'bold',
              fontSize: '16px',
              color: '#333',
            }}
          >
            {expandedSubject === subject ? '▼' : '▶'} Subject : {subject}
          </div>

          {expandedSubject === subject && (
            <div style={{ marginLeft: '20px', marginTop: '8px' }}>
              <p>
                <strong>Strong:</strong>{' '}
                {performance.strong.length > 0 ? performance.strong.join(', ') : 'None'}
              </p>
              <p>
                <strong>Moderate:</strong>{' '}
                {performance.moderate.length > 0 ? performance.moderate.join(', ') : 'None'}
              </p>
              <p>
                <strong>Weak:</strong>{' '}
                {performance.weak.length > 0 ? performance.weak.join(', ') : 'None'}
              </p>
            </div>
          )}
        </div>
      ))}
*/}
      <h2 style={{ textAlign: 'center', marginBottom: '30px' }}>📝 Your AI Test History</h2>

      {results.length === 0 ? (
        <p style={{ textAlign: 'center', color: '#666' }}>No test results found.</p>
      ) : (
        results.map((result, index) => (
          <div
            key={result.id}
            onClick={() => toggleExpand(index)}
            style={expandedIndex === index ? cardHoverStyle : cardStyle}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <h3 style={{ margin: '0 0 5px 0', fontSize: '1.1rem' }}>
                  📖 Subject: {result.subject}
                </h3>
                <h3 style={{ margin: '0 0 5px 0', fontSize: '1.1rem' }}>
                  📝 Lesson: {result.lesson}
                </h3>
                <h3 style={{ margin: '0 0 5px 0', fontSize: '1.1rem' }}>
                  📝 Topic: {result.topic}
                </h3>
                <h3 style={{ margin: '0 0 5px 0', fontSize: '1.1rem' }}>
                  📅 {result.timestamp.toDate().toLocaleString()}
                </h3>
                <p style={{ margin: 0, color: '#333' }}>
                  🔢 Score: <strong>{result.score}</strong> / {result.answers.length}
                </p>
              </div>
              <div style={{ fontSize: '1.2rem', color: '#888' }}>
                {expandedIndex === index ? '▲ Hide Details' : '▼ Show Details'}
              </div>
            </div>

{/* Condition added here: Only render if result.Quiz_Text exists */}
            {result.Quiz_Text && (
              <div style={{ display: 'flex', gap: '10px', marginTop: '20px', flexWrap: 'wrap' }}>
                <button
                  onClick={(e) => {
                    e.stopPropagation(); // Prevents the card from collapsing
                    navigate('/SameQuiz', { state: {
                      Quiz_Text: result.Quiz_Text,
                      subject: result.subject,
                      topic: result.topic,
                      format: result.format,
                      standard: result.standard,
                      lesson: result.lesson,
                      school: result.school, 
                      originalQuizId: result.id
                    }});
                  }}
                  style={{ flex: 1, minWidth: '150px', padding: '12px', background: '#4a90e2', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}
                >
                  🔄 Retake Same Quiz
                </button>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate('/SimilarQuiz', { state: {
                      Quiz_Text: result.Quiz_Text,
                      subject: result.subject,
                      topic: result.topic,
                      format: result.format,
                      standard: result.standard,
                      lesson: result.lesson,
                      lessonId: result.lessonId || 'Unknown',
                      school: result.school, 
                      originalQuizId: result.id
                    }});
                  }}
                  style={{ flex: 1, minWidth: '150px', padding: '12px', background: '#34d399', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}
                >
                  ✨ Take Similar Quiz
                </button>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate('/Email_Quiz', { state: {
                      Quiz_Text: result.Quiz_Text,
                      subject: result.subject,
                      topic: result.topic,
                      format: result.format,
                      standard: result.standard,
                      lesson: result.lesson,
                      school: result.school
                    }});
                  }}
                  style={{ flex: 1, minWidth: '150px', padding: '12px', background: '#8b5cf6', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}
                >
                  ↗️ Share Quiz
                </button>
              </div>
            )}
 


            {expandedIndex === index && (
              <div style={{ marginTop: '15px', animation: 'fadeIn 0.3s ease' }}>
                {result.answers.map((ans, i) => (
                  <div
                    key={i}
                    style={{
                      backgroundColor: ans.isCorrect ? '#e9f9f0' : '#fff1f1',
                      borderLeft: `5px solid ${ans.isCorrect ? '#4CAF50' : '#F44336'}`,
                      borderRadius: '8px',
                      padding: '12px',
                      marginBottom: '12px'
                    }}
                  >
                    <p style={{ marginBottom: '6px' }}>
                      <strong>Q{i + 1}:</strong> {ans.question}
                    </p>
                    <p style={{ margin: 0 }}>
                      <span>🧑‍🎓 <strong>Your Answer:</strong> {ans.userAnswer}</span><br />
                      <span>✅ <strong>Correct Answer:</strong> {ans.correctAnswer}</span><br />
                      <span>{ans.isCorrect ? '🟢 Correct' : '🔴 Incorrect'}</span>
                    </p>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
};

export default UserTestDashboard;
